<template>
  <div class="channelRecord">
    <PageNav :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{ $t("Customersmanage.daa") }}</span>
            </div>
          </div>
          <div class="custoMersmanage-container">
            <div class="content" style="padding-top: 0">
              <div class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      class="select-mini"
                      style="width: 150px"
                      @change="filterCourseCat"
                      v-model="filter.coursetype_id"
                      clearable
                      filterable
                      :placeholder="$t('Customersmanage.dab')"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in filter.coursetypeList"
                        :key="index"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      class="select-mini"
                      style="width: 150px"
                      v-model="filter.coursecat_id"
                      size="small"
                      clearable
                      filterable
                      :placeholder="$t('Customersmanage.dac')"
                      @change="keyWords"
                    >
                      <el-option
                        v-for="(item, index) in filter.courseCatList"
                        :key="index"
                        :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                        :value="item.coursecat_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      style="width: 180px"
                      v-model="filter.keyword"
                      @clear="keyWords()"
                      @keyup.enter.native="keyWords"
                      clearable
                      :placeholder="$t('Customersmanage.dad')"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    style="margin-right: 0px"
                    @click="keyWords"
                    >{{ $t("Customersmanage.an") }}</el-button
                  >
                </div>

                <div class="week-box">
                  <div class="week">
                    <span class="prev operate" @click="onClickPreNextMonth(-1)"
                      ><i class="el-icon-arrow-left"></i
                    ></span>
                    <span class="weeks weeks1 font-333 pl5"
                      >{{ computedDisplay }}月</span
                    >
                    <span class="next operate" @click="onClickPreNextMonth(1)"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </div>
                <div class="schedule-right">
                  <ul>
                    <li>
                      <span class="state state1"></span>
                      正式课
                    </li>
                    <li>
                      <span class="state state2"></span>
                      {{ $t("Customersmanage.dae") }}
                    </li>
                    <li>
                      <span class="state state5"></span>
                      {{ $t("Customersmanage.daf") }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="pl20 pr20">
                <div class="tabList" ref="inviteTable">
                  <invite-table
                    :tableData="tableList"
                    @onClickItem="onClickItem"
                  ></invite-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import inviteTable from "@/components/tables/inviteTable.vue";

import channelRecordRequest from "./channelRecord.js";
import helper from "./helper";

export default {
  name: "CustoMersmanage-inviteReport",
  data() {
    let [year, month] = helper.getYearMonthDate(new Date());

    return {
      openMenu: ["3"],
      display: { year, month },
      filter: {
        coursetype_id: "",
        coursetypeList: [],
        coursecat_id: "",
        courseCatList: [],
        keyword: "", // 筛选
      },

      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          tableHeight: 0,
        },
      },
    };
  },
  components: {
    PageNav,
    inviteTable,
  },
  created() {
    this.inviteTimetableApi(); //课务管理->获取班级的周课表
    this.getTypeCourseCatApi();
    this.courseTypeApi();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["inviteTable"]) {
        this.tableList.options.tableHeight = this.$Tool.getTableHeight(
          this.$refs.inviteTable.getBoundingClientRect().top + 45
        );
      }
    });
  },
  computed: {
    computedDisplay() {
      return this.display.year + "-" + helper.padLeft(this.display.month + 1);
    },
  },
  methods: {
    inviteTimetableApi() {
      channelRecordRequest
        .inviteTimetableApi({
          month: this.computedDisplay,
          keyword: this.filter.keyword,
          coursetype_id: this.filter.coursetype_id,
          coursecat_id: this.filter.coursecat_id,
        })
        .then((res) => {
          this.tableList.columns = res.data.data.field;
          if (res.data.code === 200) {
            this.tableList.list = res.data.data.list;
          } else {
            this.tableList.list = [];
            this.tableList.options.errortip = res.data.msg;
          }
          (() => {})(this.tableList);
        });
    },
    courseTypeApi() {
      channelRecordRequest.courseTypeApi({}).then((res) => {
        if (res.data.code === 200) {
          this.filter.coursetypeList = res.data.data.list;
        } else {
          this.filter.coursetypeList = [];
        }
      });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.keyWords();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filter.courseCatList = data.list;
          } else {
            this.filter.courseCatList = [];
          }
        });
    },

    //课程详情-点击
    onClickItem() {},

    onClickPreNextMonth(length) {
      const oldDate = new Date(this.display.year, this.display.month);
      const newDate = helper.addMonth(oldDate, length);
      const [year, month] = helper.getYearMonthDate(newDate);
      this.display = { year, month };
      this.inviteTimetableApi();
    },

    //关键字-查询
    keyWords() {
      this.inviteTimetableApi();
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("channelRecord.less");

.channelRecord {
  height: 100vh;
  font-size: 20px;
  .week-box {
    margin-bottom: 10px;

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    .week {
      margin-left: 40px;
      color: #aaaaaa;
      font-size: 14px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      .operate {
        width: 32px;
        height: 23px;
        line-height: 23px;
        border-radius: 4px;
        cursor: pointer;
        border: 1px solid #aaaaaa;
        text-align: center;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
  .schedule-right {
    margin-bottom: 10px;
    margin-left: auto;
    color: #333333;
    font-size: 14px;
    .state1 {
      background-color: #6ce3b2;
    }
    .state2 {
      background-color: #20a8d8;
    }
    .state3 {
      background-color: #cccccc;
    }
    .state4 {
      background-color: #ff0000;
    }
    .state5 {
      background-color: rgba(255, 203, 0, 1);
    }
    ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      li {
        margin-right: 20px;
        span {
          width: 24px;
          height: 24px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
